import { useEffect } from 'react';
import { useBranding } from 'hooks/useBranding';
import { TENANT_NAME } from 'constants/tenant-config';

const pendoId = 'pendo-script';

const getPendoJsIntegration = (apiKey) => `(function(apiKey){
  (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
  v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
      o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
      y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
      z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
})('${apiKey}');`;

const getPendoApiKeyFromTenant = (tenantKey) => {
  const envKey = `REACT_APP_PENDO_API_KEY_${tenantKey}`;
  return process.env[envKey];
};

// Please double check with Pendo setting in Google Tag Manager
// Make sure only one of them is enabled to avoid duplicated data
// Recommended to use Pendo setting in Code to manage accross different tenants more easily
const withPendo = (Component) => {
  const WrappedComponent = (props) => {
    const { domainConfig } = useBranding();
    const domainKey = domainConfig?.domainKey;
    const isTIBTenant = domainKey === TENANT_NAME.TIB;

    useEffect(() => {
      // Only inject Pendo for TIB tenant (remove this condition to enable for other tenants)
      if (!isTIBTenant) {
        const existingPendoScript = document.getElementById(pendoId);
        if (existingPendoScript) {
          document.body.removeChild(existingPendoScript);
        }
        return;
      }

      const pendoApiKey = getPendoApiKeyFromTenant(domainKey);

      if (!pendoApiKey) {
        return;
      }

      const checkExistPendoScriptElement = document.getElementById(pendoId);

      if (checkExistPendoScriptElement) {
        return;
      }

      const pendoScript = document.createElement('script');
      pendoScript.id = pendoId;

      pendoScript.innerText = getPendoJsIntegration(pendoApiKey);
      pendoScript.async = true;

      document.body.appendChild(pendoScript);

      return () => {
        const existingPendoScript = document.getElementById(pendoId);
        if (existingPendoScript) {
          document.body.removeChild(existingPendoScript);
        }
      };
    }, [isTIBTenant, domainKey]);

    return <Component {...props} />;
  };

  return WrappedComponent;
};

export default withPendo;
